import React from 'react';
import Background from '../components/Background';
import About from '../components/About';
import JourneyTimeline from '../components/JourneyTimeline';

const AboutPage = () => {
  return (
    <>
      <Background />
      <div className="page">
        <About />
        <JourneyTimeline />
      </div>
    </>
  );
};

export default AboutPage;
